export type TouchManagerEvent = {
  movementX: number;
}

export class TouchManager {

  private prevTouch: TouchEvent | null;

  constructor() { 
    this.prevTouch = null;
  }
  
  start(event: TouchEvent) {
    this.prevTouch = event;
  }

  move(event: TouchEvent) {
    const movementX = this.prevTouch ?
      event.touches[0].clientX - this.prevTouch.touches[0].clientX
      : 0;
    this.prevTouch = event;
    return { movementX };
  }

}